export default "__VITE_ASSET__7b0a084d__"